import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getGalleryImages } from '../api';
import ImageLightbox from './ImageLightbox'; // предполагается, что он уже есть

const GallerySection = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    getGalleryImages('main')
      .then(data => {
        setImages(Array.isArray(data) ? data.slice(0, 8) : []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `http://localhost:5000${path}`;
  };

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  if (loading) return <div>Загрузка галереи...</div>;
  if (images.length === 0) return null;

  return (
    <section className="gallery-section">
      <div className="container">
        <h2 className="section-title">Фотографии с мероприятий</h2>
        <div className="gallery-grid">
          {images.map((img, idx) => (
            <div key={img.id} className="gallery-item" onClick={() => openLightbox(idx)}>
              <img src={getImageUrl(img.path)} alt={img.originalName} />
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/gallery" className="btn">Все фото</Link>
        </div>
      </div>
      {lightboxOpen && (
        <ImageLightbox
          images={images.map(img => getImageUrl(img.path))}
          currentIndex={lightboxIndex}
          onClose={(newIndex) => {
            if (typeof newIndex === 'number') setLightboxIndex(newIndex);
            else setLightboxOpen(false);
          }}
        />
      )}
    </section>
  );
};

export default GallerySection;